var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35171 8.74659C5.82852 11.6489 8.20783 14.018 11.1102 15.5051L13.3664 13.2488C13.6433 12.9719 14.0536 12.8796 14.4125 13.0027C15.5611 13.3821 16.8021 13.5873 18.0738 13.5873C18.6378 13.5873 19.0993 14.0488 19.0993 14.6128V18.192C19.0993 18.7561 18.6378 19.2176 18.0738 19.2176C8.44371 19.2176 0.63916 11.4131 0.63916 1.783C0.63916 1.21894 1.10066 0.757431 1.66473 0.757431H5.25421C5.81827 0.757431 6.27977 1.21894 6.27977 1.783C6.27977 3.06495 6.48488 4.29563 6.86434 5.44427C6.97716 5.80321 6.89511 6.20318 6.60795 6.49034L4.35171 8.74659Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5dc08b0db9b31e9f5bbdb12ecbc2844b.svg";
export { ForwardRef as ReactComponent };